import { Directive } from "@angular/core";

@Directive({
  selector: '[listItem]'
})
export class CheckListItemDirective {}
